import { createContext, useContext, useState, useCallback } from "react";

const AppContext = createContext(null);

export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [composer, setComposer] = useState(null); // { channel, parties, defaultParty, subjectHint }

  const openComposer = useCallback((cfg) => setComposer(cfg || {}), []);
  const closeComposer = useCallback(() => setComposer(null), []);

  return (
    <AppContext.Provider value={{ composer, openComposer, closeComposer }}>
      {children}
    </AppContext.Provider>
  );
}
